<template>
	<div class="container bg-white p-3 border-15 shadow">
		<multi_step_progress
		:stepper_array="['احراز هویت', 'اطلاعات فردی', 'اطلاعات تکمیلی', 'اطلاعات تدریس', 'اطلاعات تحصیلی', 'درباره من', 'ارزیابی']"
		:stepper_warning="[]"
		:stepper_danger="[]"
		:completed="4"
		/>
		<multiSelectInput 
		:flds="$localStorage.get('field').data" 
		label="مقطع تحصیلی" 
		:value="set_field()" 
		@input="(e) => { val.value.field = e.toString(); p_sav('field'); }"
		/>
		<div class="w-100 overflow-hidden">
			<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 float-right p-0">				
				<textareaInput 
					label="مدارک تحصیلی (این مدارک به کاربران نمایش داده نمی شود)"
					:value="val.value.documents"
					@inputTxtFunc="(e) => { val.value.documents = e;  }" 
					@blurinputTxtFunc="(e) => { p_sav('documents') }" 
				/>
			</div>

			<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 float-right"
				:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
				<file_cloud 
					label="بارگزاری مدارک تحصیلی (به کاربر نمایش داده نمی شود.)" 
					:error="false"
					:files="val.value.pic_documents"
					@chengeFile="(e) => { uploadTF('pic_documents', e[0]);  }"
					@removeFile="(e) => { val.value.pic_documents = e;  p_sav('pic_documents'); }"
				/>
			</div>
		</div>
		<div class="w-100 overflow-hidden">
			<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 float-right p-0">				
				<textareaInput 
					label="مدارک، افتخارات و جوایز (اختیاری) (به کاربر نمایش داده می شود.)"
					:value="val.value.certificate"
					@inputTxtFunc="(e) => { val.value.certificate = e;  }"
					@blurinputTxtFunc="(e) => { p_sav('certificate') }" 
				/>
			</div>
			<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 float-right"
				:class="(windowWidth > 770) ? 'pl-0' : 'p-0'">
				<file_cloud 
					label="بارگزاری تصاویر مدارک، افتخارات و جوایز (به کاربر نمایش داده می شود.)"
					:error="false"
					:files="val.value.files.f2"
					@chengeFile="(e) => { uploadTF('f2', e[0]);  }"
					@removeFile="(e) => { val.value.files.f2 = e;  p_sav('files'); }"
				/>
			</div>
		</div>
		<btn 
			class="pt-3 w-100" 
			textClass="w-100" 
			text="مرحله بعدی"
			@clickMe="setPage();"
		/>
	</div>
</template>

<script>
	import btn from "../../UI/button/btn.vue";
	import multiSelectInput from "../../UI/input/multiSelectInput.vue";
	import textareaInput from "../../UI/input/textareaInput.vue";
	import multi_step_progress from "../../UI/progress/multi_step_progress.vue";
	import { indexFinder } from "../../assets/library/filter.js";
	import file_cloud from "../../UI/uploadFile/file_cloud.vue";
	import { success, error, loading, success_sm } from "../../assets/library/messege.js";

	export default {
		name: 'educational_information',
		data(){
			return {
				indexFinder: indexFinder,
				success_sm: success_sm,
				error: error,
				success: success,
				loading: loading,
			}
		},
		components: {
			btn,
			multi_step_progress,
			multiSelectInput,
			file_cloud,
			textareaInput,
		},
		props: {
			val: {
				default: {
					page: 1,
				},
			},
		},
		mounted(){

		},
		methods:{
set_field(){
	var f = [];
	if(this.val.value.field != 0){
		f = this.val.value.field.split(',').map(function(item) {
			return parseInt(item, 10);
		});
	}
	return f;
},
//********************************************** */
uploadTF(val, e, THIS = this) {
	THIS.loading(THIS);
	var formData = new FormData();
	formData.append("file", e);
	formData.append("format", ["jpg", "jpeg", "png", "pdf"]);
	formData.append("idImg", "t_[DATE]_[RANDOM]");
	var xhttp = new XMLHttpRequest();
	xhttp.open("POST", window.upldurl, true);
	xhttp.onreadystatechange = function () {
		if (this.readyState == 4 && this.status == 200) {
			this.getVar = JSON.parse(this.responseText);
			if (this.getVar.response == 1) {
				let F = {
					fileName: this.getVar.filename,
					fileUpload: this.getVar.uploadFileName,
				};
				if(val!='f2') THIS.val.value[val].push(F);
				else  THIS.val.value.files.f2.push(F);
				THIS.p_sav(val);
				THIS.success_sm(THIS);
			} else {
				THIS.error(THIS, "فرمت فایل باید jpg باشد");
			}
		}
	};
	xhttp.send(formData);
},
//********************************************************** */
setPage(){
	if(this.val.value.field=='' || this.val.value.field=='0' || this.val.value.documents==''  || this.val.value.certificate=='' || this.val.value.pic_documents.length==0  || this.val.value.files.f2.length==0  ){
		this.error(this);
	}else{
		this.val.page = 7;
		this.$emit('next_page', this.val);
	}
},
//********************************************************** */
degrees_data(){
	let deg = [];
	let degrees = this.$localStorage.get('degrees').data;
	var D = this.val.value.degrees.split(',').map(function(item) {
		return parseInt(item, 10);
	});
	for (var i = 0; i < degrees.length; i++) {
		if (D.includes(degrees[i].id)) {
			deg.push(degrees[i].id);
		}
	}
	return deg;
},
//********************************************************** */
p_sav(fild) {
	fild = (fild == "f2") ? 'files' : fild;
	let v = this.val.value[fild];
	if(this.$localStorage.get('user')) {
		window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: fild ,val: v, id: this.val.id, admin: this.$localStorage.get('user')}, function () {
		
		}, "json");
	} else {
		window.$.post(window.baseurl + 'accountTeacher/step_teacher', {fild: fild ,val: v, id: this.val.id}, function () {
		
		}, "json");
	}

},
	}
}
</script>
<style>

</style>
